import saleFA from './fa/fa.json'

const SaleMessages = {
  fa: { ...saleFA },
}

export default SaleMessages
